// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"9023807b2770699a708a","678":"a763c19a7a5947abaaee","883":"35ad1d6f4f23ad382d4e"}[chunkId] + ".js";
};